import React, { useEffect, useState } from "react";
import { Modal, Typography, Table, Card, Row, Col, Image } from "antd";
import axios from "axios";

const { Title, Text } = Typography;

const OrderDetailsModal = () => {
  const [modalWidth, setModalWidth] = React.useState(1200); // Adjust modal width as needed
  const [vendorId, setVendorId] = useState(null);
  const [orderData, setOrderData] = useState([]);
  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);

    if (VendorId) {
      fetchUnshippingOrders(VendorId);
    }
  }, []);

  const fetchUnshippingOrders = async (vendorId) => {
    try {
      const response = await axios.post(
        "https://app-tl2d3sc25q-uc.a.run.app/api/products_sales_report_byvendor_filter",
        {
          vendor_id: vendorId,
        }
      );

      const data = response.data;
      console.log("Vendor Details:", data);
      setOrderData(data); // Store vendor details in state
      console.log("Setting modal visibility to true");
    } catch (error) {
      console.error("Error fetching vendor details:", error);
      // Handle error state if needed
    }
  };
  const columns = [
    {
      title: "Product Id",
      dataIndex: "product_id",
      key: "product_id",
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "Total Quantity Sold",
      dataIndex: "total_quantity_sold",
      key: "total_quantity_sold",
      render: (text) => `${text}`,
    },

    {
      title: "Product Image",
      dataIndex: "product_image_url",
      key: "product_image_url",
      render: (text) => (
        <Image src={text} alt="Product" style={{ width: 100 }} />
      ),
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {/* Order Information Card */}

      {/* Order Items Card */}
      <Col span={24}>
        <Card title="Vendor Products" bordered={false}>
          <Table columns={columns} dataSource={orderData} rowKey="product_id" />
        </Card>
      </Col>
    </Row>
  );
};

export default OrderDetailsModal;
